import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const STORAGE_KEY = 'auth';

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : {};
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
    }, [auth]);

    const updateAuth = (data) => {
        setAuth((prev) => ({ ...prev, ...data }));
    };

    // ฟังก์ชันลบ localStorage และ reset state
    const clearAuth = () => {
        localStorage.removeItem(STORAGE_KEY);
        setAuth({});
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, updateAuth, clearAuth }}>
            {children}
        </AuthContext.Provider>
    );
};